var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Axios from "axios";
import { showError, showSuccess } from "@spike/notifications-action";
import { ADD_ON_SERVICES_CHANGE_STATE_SUCCESS_ACTION_TYPE, ADD_ON_SERVICES_DELETE_START_ACTION_TYPE, ADD_ON_SERVICES_DELETE_SUCCESS_ACTION_TYPE, ADD_ON_SERVICES_ERROR_ACTION_TYPE, ADD_ON_SERVICES_FETCH_START_ACTION_TYPE, ADD_ON_SERVICES_FETCH_SUCCESS_ACTION_TYPE, ADD_ON_SERVICES_RESET_ACTION_TYPE, ADD_ON_SERVICES_SAVE_START_ACTION_TYPE, ADD_ON_SERVICES_SAVE_SUCCESS_ACTION_TYPE, } from "./AddOnServicesActionsTypes";
import { convertToAddOnService } from "./AddOnServicesConverter";
var addOnServicesUrl = "/addon_services";
export var resetServicesThunk = function () {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            dispatch(reset());
            return [2 /*return*/];
        });
    }); };
};
export var fetchThunk = function (apiClientWrapper) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, response, apiError_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(fetchStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(addOnServicesUrl, "?marketplace_id=").concat(marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(fetchSuccess(response.data));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_1 = _a.sent();
                    if (!Axios.isCancel(apiError_1)) {
                        dispatch(error());
                        dispatch(showError("Error fetching add-on services."));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var saveThunk = function (apiClientWrapper, service) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, apiClientMethod, url, response, apiError_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(saveStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    apiClientMethod = service.id === undefined ? apiClientWrapper.apiClient.post : apiClientWrapper.apiClient.patch;
                    url = service.id === undefined
                        ? "".concat(addOnServicesUrl, "?marketplace_id=").concat(marketplaceId)
                        : "".concat(addOnServicesUrl, "/").concat(service.id, "?marketplace_id=").concat(marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientMethod(url, {
                            "addon_service": {
                                id: service.id,
                                uuid: service.uuid,
                                marketplace_id: marketplaceId,
                                name: service.name,
                                price: service.price,
                                active: service.active,
                                olb_enabled: service.olbEnabled,
                                tax_ids: service.taxes.map(function (tax) { return (tax.id); })
                            }
                        }, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(saveSuccess(response.data));
                    dispatch(showSuccess("Add-on service saved."));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_2 = _a.sent();
                    if (!Axios.isCancel(apiError_2)) {
                        dispatch(error());
                        dispatch(showError("Error saving add-on service."));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var deleteThunk = function (apiClientWrapper, serviceId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, apiError_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(deleteStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(addOnServicesUrl, "/").concat(serviceId, "?marketplace_id=").concat(marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.delete(url, apiClientWrapper.requestConfig)];
                case 2:
                    _a.sent();
                    dispatch(deleteSuccess(serviceId));
                    dispatch(showSuccess("Add-on service deleted."));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_3 = _a.sent();
                    if (!Axios.isCancel(apiError_3)) {
                        dispatch(error());
                        dispatch(showError("Error deleting add-on services."));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var changeStateThunk = function (apiClientWrapper, serviceId, active) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, response, apiError_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(addOnServicesUrl, "/").concat(serviceId, "?marketplace_id=").concat(marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.patch(url, {
                            id: serviceId,
                            active: active,
                        }, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(changeStateSuccess(response.data));
                    dispatch(showSuccess("Add-on service changed."));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_4 = _a.sent();
                    if (!Axios.isCancel(apiError_4)) {
                        dispatch(error());
                        dispatch(showError("Error change status add-on service."));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var reset = function () {
    return {
        type: ADD_ON_SERVICES_RESET_ACTION_TYPE,
    };
};
var fetchStart = function () {
    return {
        type: ADD_ON_SERVICES_FETCH_START_ACTION_TYPE,
    };
};
export var fetchSuccess = function (servicesDto) {
    return {
        type: ADD_ON_SERVICES_FETCH_SUCCESS_ACTION_TYPE,
        payload: {
            services: servicesDto.map(function (service) { return convertToAddOnService(service); }),
        },
    };
};
var saveStart = function () {
    return {
        type: ADD_ON_SERVICES_SAVE_START_ACTION_TYPE,
    };
};
var saveSuccess = function (serviceDto) {
    return {
        type: ADD_ON_SERVICES_SAVE_SUCCESS_ACTION_TYPE,
        payload: {
            service: convertToAddOnService(serviceDto),
        },
    };
};
var deleteStart = function () {
    return {
        type: ADD_ON_SERVICES_DELETE_START_ACTION_TYPE,
    };
};
var deleteSuccess = function (id) {
    return {
        type: ADD_ON_SERVICES_DELETE_SUCCESS_ACTION_TYPE,
        payload: {
            id: id,
        },
    };
};
var changeStateSuccess = function (serviceDto) {
    return {
        type: ADD_ON_SERVICES_CHANGE_STATE_SUCCESS_ACTION_TYPE,
        payload: {
            service: convertToAddOnService(serviceDto),
        },
    };
};
var error = function () {
    return {
        type: ADD_ON_SERVICES_ERROR_ACTION_TYPE,
    };
};
